import { ErrorType } from '../../../templateeditor/components/FieldValidations/constants';
import { FormEditorState } from '../../formeditor-types';
import { getInvalidFieldValues } from './helpers/validatedFieldsHelpers';
import { getViewPositionForFields } from './helpers/validationErrorsPopupHelpers';

export const getErrorFields = (state) => {
  const invalidFieldValues = getInvalidFieldValues(state);
  return invalidFieldValues?.filter((x) => x.errorSettings.errorType === ErrorType.Error) || [];
};

export const getWarningFields = (state) => {
  const invalidFieldValues = getInvalidFieldValues(state);
  return invalidFieldValues?.filter((x) => x.errorSettings.errorType === ErrorType.Warning) || [];
};

export function getViewPositionsForFieldIds(state: FormEditorState, fieldIds: string[]) {
  return getViewPositionForFields(state, fieldIds);
}
